import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";

const ProductCard = ({ product, showCountdown = false, timeLeft = null, imgHeight = '240px' }) => {
  const { addToCart, isInCart } = useCart();
  const { toggleWishlist, isInWishlist } = useWishlist();

  const variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
  const price = variant ? variant.price : (product.price || 0);
  const image = (product.imageUrls && product.imageUrls[0]) || "assets/images/thumbs/product-img1.png";
  const isWishlisted = isInWishlist(product.id);
  const inCart = isInCart(product.id, variant?.id);

  return (
    <div className='product-card h-100 w-100 p-12 border border-gray-100 hover-border-main-600 rounded-20 bg-white shadow-sm hover-shadow-md position-relative transition-3' style={{ transition: 'all 0.3s ease-in-out', width: '100%' }}>

      {/* Thumbnail Section */}
      <div className={`product-card__thumb rounded-16 position-relative overflow-hidden ${imgHeight ? '' : 'product-card-thumb-responsive'}`} style={imgHeight ? { height: imgHeight } : undefined}>
        <Link to={`/product-details?id=${product.id}`} className='product-card__img-link w-100 h-100 d-block'>
          <img
            src={image}
            alt={product.name}
            className='product-card__img transition-3'
            style={{
              transform: 'scale(1)',
              transition: 'transform 0.4s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          />
        </Link>

        {/* Top Badges */}
        <div className='position-absolute inset-block-start-0 inset-inline-start-0 m-12 z-1 d-flex flex-column gap-8'>
          {product.isHot && (
            <span className='bg-danger-600 text-white px-10 py-4 rounded-pill text-xs fw-bold shadow-sm'>
              HOT
            </span>
          )}
        </div>

        {/* Quick Actions (Wishlist & View) */}
        <div className='position-absolute inset-inline-end-0 inset-block-start-0 m-12 z-1 d-flex flex-column align-items-center gap-8 transition-3'>
          <button
            type='button'
            onClick={() => toggleWishlist(product)}
            className={`w-36 h-36 rounded-circle shadow-sm d-flex align-items-center justify-content-center transition-2 ${isWishlisted ? 'bg-main-600 text-white' : 'bg-white text-neutral-600 hover-bg-main-600 hover-text-white'}`}
          >
            <i className={isWishlisted ? 'ph-fill ph-heart' : 'ph ph-heart'} style={{ fontSize: '18px', lineHeight: 1 }} />
          </button>
        </div>
      </div>

      {/* Content Section */}
      <div className='product-card__content mt-16 px-4 w-100 d-flex flex-column align-items-stretch'>
        <div className='flex-align justify-content-between gap-4'>
          <span className='text-xs fw-medium text-gray-500 uppercase tracking-wider'>{product.category || product.categoryName || "VedhaCultures"}</span>
          {/* <div className='flex-align gap-4'>
                <i className='ph-fill ph-star text-warning-600 text-xs' />
                <span className='text-xs fw-bold text-gray-700'>4.8</span>
            </div> */}
        </div>

        <h6 className='title text-md fw-bold mt-8 mb-12'>
          <Link to={`/product-details?id=${product.id}`} className='link text-line-1 hover-text-main-600 transition-2'>
            {product.name}
          </Link>
        </h6>

        <div className='product-card__price flex-align gap-8 mb-20'>
          <span className='text-main-600 text-lg fw-bold'>
            Rs.{price}
          </span>
        </div>

        <button
          onClick={() => {
            addToCart(product, variant);
          }}
          disabled={inCart}
          className={`btn ${inCart ? 'bg-gray-300' : 'bg-main-600'} text-white w-100 py-12 rounded-12 d-flex justify-content-center align-items-center gap-8 fw-bold hover-bg-main-700 transition-2 shadow-sm`}
          style={{ width: '100%', display: 'flex', justifyContent: 'center', opacity: inCart ? 0.8 : 1, cursor: inCart ? 'not-allowed' : 'pointer' }}
        >
          <i className={inCart ? 'ph ph-check-circle text-lg' : 'ph ph-shopping-cart text-lg'} />
          <span>{inCart ? 'Added to Cart' : 'Add To Cart'}</span>
        </button>
      </div>

      <style>{`
        .product-card {
            background: white !important;
        }
        .product-card:hover {
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
        }
        .product-card__content {
            display: flex !important;
            flex-direction: column !important;
            align-items: stretch !important;
        }
        .product-card .btn {
            width: 100% !important;
            min-width: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
        }
        .product-card__img-link, 
        .product-card__img-link img {
            width: 100% !important;
            min-width: 100% !important;
            height: 100% !important;
            display: block !important;
            object-fit: cover !important;
        }

        @media (max-width: 575px) {
          .product-card__thumb {
            height: 160px !important;
          }
          .product-card__content {
            margin-top: 10px !important;
            padding-left: 8px !important;
            padding-right: 8px !important;
          }
          .product-card__price span {
            font-size: 1rem !important;
          }
          .product-card .btn {
            padding: 8px 12px !important;
            font-size: 0.875rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductCard;